const ColorPickerBoxStyle = theme => ({
  
});

export default ColorPickerBoxStyle;
